import React, { useState,useRef } from "react";
import {Formulario} from "../../globals/dhtmlx/Form";
import FormErrorMessage from "../../globals/FormErrorMessage";
import styled from "styled-components";
import "../../../dhtmlx/codebase/suite.css";
import Button from "../../globals/Button";
import {showAlert} from "../../globals/Message";
import { apiCall } from "../../../helpers/ApiCalls";
import { useHistory } from "react-router-dom";
import ReCAPTCHA from 'react-google-recaptcha';

/**ESTILOS */
const recaptcha_key = process.env.REACT_APP_RECAPTCHA;

const Container = styled.section`
width: 100%;
display: ${props => props.show};
justify-content: center;
align-content: center;
height: auto;
padding: 16px 0 16px 0;
`;
const LoginMessage = styled.span`
color: red;
text-align: center;
font-size: 18px;
`;
function SignIn(props){
  let history = useHistory();
  const [inputs, setInputs] = useState({});
  const [valid, setValid] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [captchaValido, setCaptchaValido] = useState(process.env.REACT_APP_ENTORNO ==='Dev'?true:false);
  const captcha = useRef(null);
  const [loginMessage, setLoginMessage] = useState("");
  const [showLoginMessage, setShowLoginMessage] = useState(false);
  
  async function registrarUsuario(){
    setButtonLoading(true);
    if(captchaValido && valid && Object.keys(inputs).length >0){
      //hacemos la llamada a la API de
      const params = {
        nombre:inputs.nombre,
        apellido:inputs.apellido,
        email:inputs.singin_email,
        password:inputs.singin_password,
      }
      await apiCall('POST','registro',params).then((res)=>{
        if(res.success && res.code === 200){
          showAlert('Usuario Registrado con exito', ()=>{
            window.location.reload();
          });

        }
        else{
          if(res){
            setLoginMessage("No se pudó registrar intenta de nuevo");
          }
          else{
            setLoginMessage("Tenemos problemas, por favor intenta mas tarde.");
          }
          setShowLoginMessage(true);
        }
      });
      setButtonLoading(false);
    }else{
      setButtonLoading(false);
      if(!captchaValido){
        setLoginMessage("Por favor valida tu identidad");
        setShowLoginMessage(true);
      }
    }

  }
  const rows = [
    {
      id: "nombre",
      type: "input",
      label: "Nombre",
      placeholder: "Juan",
      preMessage: "Ingresa tus nombres",
      errorMessage: "El nombre es obligatorio",
      successMessage: "Nombre valido",
      required: true,
    },
    {
      id: "apellido",
      type: "input",
      label: "Apellido",
      placeholder: "Lopez",
      preMessage: "Ingresa tus apellidos",
      errorMessage: "El apellido es obligatorio",
      successMessage: "Apellido valido",
      required: true,
    },
    {
      id: "singin_email",
      type: "input",
      label: "Email",
      placeholder: "jd@mail.name",
      preMessage: "Enter Email",
      errorMessage: "Ingresa un email",
      successMessage: "Email valido",
      validation: "email",
      required: true,
    },
    {
      id: "singin_password",
      type: "input",
      inputType: "password",
      label: "Contraseña",
      placeholder: "********",
      errorMessage: "Ingresa la contraseña",
      required: true,
    }
  ];
  function changeCaptcha (){
    if(captcha.current.getValue()){
      setCaptchaValido(true);
    }
    else{
      setCaptchaValido(false);

    }
  }
  return (
    <Container id={'signin-container'} show={props.show?'grid':'none'}>
     
      <Formulario
        rows={rows}
        padding = {0}
        width = {'300px'}
        toggleInputs = {setInputs}
        toggleValid = {setValid}
        toogleMessage = {()=>{}}
        loading = {buttonLoading}

      />
       <div id="google_recaptcha" style={{margin:'-16px 0 16px 0'}}>
        <ReCAPTCHA
          ref={captcha}
          sitekey={recaptcha_key}
          onChange={changeCaptcha}
        />
      </div>
      <Button width={'100%'} flat = {true} onClick={registrarUsuario} loading={buttonLoading}>Crear Registro</Button>
      <FormErrorMessage 
        id="login_message"
        showMessage={showLoginMessage}
        message={loginMessage}
        toggleMessage = {setShowLoginMessage}
        width={'300px'}
      />
    </Container>
    
  );
}
export default SignIn; 